"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnhanceChildren = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const EnhanceChildren = (props) => {
    const { children, enhance } = props;
    const newChildren = react_1.Children.map(children, (child) => {
        if (typeof child === "object" && child !== null && "type" in child) {
            return react_1.cloneElement(child, Object.assign({}, enhance));
        }
        return child;
    });
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: newChildren }, void 0);
};
exports.EnhanceChildren = EnhanceChildren;
//# sourceMappingURL=EnhanceChildren.js.map